import React from 'react';

import style from './AsideMenu.module.scss';

import AppLink from 'components/AppLink/AppLink';
import Icon from 'components/Icon/Icon';
import classNames from 'classnames';

interface Props {
  iconType: React.ComponentProps<typeof Icon>['type'];
  className?: string;
  to: string;
  description?: JSX.Element;
  children: React.ReactNode;
}

const NavigationItem = ({
  iconType,
  className,
  to,
  description,
  children,
}: Props) => {
  return (
    <li>
      <AppLink
        to={to}
        className={classNames(style.link, className)}
        activeClass={style.link__active}
      >
        <Icon className={style.link__icon} aria-label="icon" type={iconType} />

        <div className={style.link__textWrapper}>
          <span className={style.link__text}>{children}</span>
          {!!description && (
            <span className={style.link__description}>{description}</span>
          )}
        </div>
      </AppLink>
    </li>
  );
};

export default NavigationItem;
